import React from 'react';

const Uganda1_university_psy = () => {
  return (
    <div>
      
    </div>
  );
}

export default Uganda1_university_psy;
